<template>
    <ul class="grade_item-rating-wrap">
        <li v-for="(place, placeIndex) in places" class="rating-item" :key="'place_' + placeIndex">
            <div class="rating-name">
                <a
                    v-if="place.students.length >= 3"
                    href="#"
                    class="rating-name-expand"
                    @click.prevent="place.show = !place.show"
                >
                    {{ getExpandName(place.students.length) }}
                </a>
                <span
                    v-for="(student, studentIndex) in place.students"
                    :key="'student_' + studentIndex"
                    :style="`display: ${place.students.length >= 3 && !place.show ? 'none' : 'block'}`"
                >
                    {{ student.userFio }}
                </span>
            </div>
            <div class="rating-bar-container">
                <div class="rating-bar" :style="`width: ${place.score}%`" :onMouseOver="`this.style.background='${getScoreColor(place.score)}'`" onMouseOut="this.style.background='#F3F4F6'">
                    <div class="rating-icon">
                        <span class="rating-number">{{ placeIndex + 1 }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="getCrownClass(placeIndex + 1)">
                            <g clip-path="url(#clip0_3060_2032)">
                                <path d="M20 17H4C3.46957 17 2.96086 17.2107 2.58579 17.5858C2.21071 17.9609 2 18.4696 2 19C2 19.5304 2.21071 20.0391 2.58579 20.4142C2.96086 20.7893 3.46957 21 4 21H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19C22 18.4696 21.7893 17.9609 21.4142 17.5858C21.0391 17.2107 20.5304 17 20 17Z" fill="none" />
                                <path d="M22 5.99982C21.4696 5.99982 20.9609 6.21054 20.5858 6.58561C20.2107 6.96068 20 7.46939 20 7.99982C20.0002 8.13722 20.0143 8.27425 20.042 8.40882L16.41 10.5898L13.349 4.46782C13.6464 4.19571 13.8547 3.84006 13.9465 3.44751C14.0383 3.05496 14.0093 2.64384 13.8633 2.26806C13.7173 1.89227 13.4612 1.56937 13.1285 1.34169C12.7959 1.11401 12.4021 0.992187 11.999 0.992188C11.5959 0.992187 11.2021 1.11401 10.8695 1.34169C10.5368 1.56937 10.2807 1.89227 10.1347 2.26806C9.98873 2.64384 9.95974 3.05496 10.0515 3.44751C10.1433 3.84006 10.3516 4.19571 10.649 4.46782L7.59 10.5898L3.958 8.40882C3.98573 8.27425 3.9998 8.13722 4 7.99982C4 7.60426 3.8827 7.21758 3.66294 6.88868C3.44318 6.55978 3.13082 6.30344 2.76537 6.15206C2.39992 6.00069 1.99778 5.96108 1.60982 6.03825C1.22186 6.11542 0.865492 6.3059 0.585787 6.58561C0.306082 6.86531 0.115601 7.22168 0.0384303 7.60964C-0.0387401 7.9976 0.000866562 8.39974 0.152242 8.76519C0.303617 9.13064 0.559962 9.443 0.88886 9.66276C1.21776 9.88252 1.60444 9.99982 2 9.99982C2.037 9.99982 2.071 9.99082 2.107 9.98882L2.88 17.9998H21.12L21.893 9.98882C21.929 9.98882 21.963 9.99982 22 9.99982C22.5304 9.99982 23.0391 9.78911 23.4142 9.41404C23.7893 9.03896 24 8.53026 24 7.99982C24 7.46939 23.7893 6.96068 23.4142 6.58561C23.0391 6.21054 22.5304 5.99982 22 5.99982Z" fill="none" />
                            </g>
                            <defs>
                                <clipPath id="clip0_3060_2032">
                                    <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <p :class="{ 'score-label': place.score >= minScoreForLabel }">
                        <span><span v-if="place.score >= minScoreForLabel">Средний балл&nbsp;</span>{{ place.score }}</span>
                    </p>
                    <img v-if="place.score >= minScoreForPhoto" class="rating-icon" :src="getPhotoUrl(place.students[0])" />
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import { helpers } from '@/store/tests';

export default {
    name: 'RatingList',
    props: {
        places: { type: Array, required: true },
        full: { type: Boolean, required: false, default: true }
    },
    computed: {
        ...mapGetters({
            apiImg: 'apiImg'
        })
    },
    data() {
        return {
            minScoreForLabel: 0,
            minScoreForPhoto: 0
        }
    },
    methods: {
        getExpandName(count) {
            let countString = count.toString();
            let lastDigit = countString.slice(-1);
            let beforeLastDigit = countString.length >= 2 ? countString.charAt(countString.length - 2) : '';

            if (lastDigit === '1' && beforeLastDigit !== '1') {
                return count + ' студент';
            }
            
            if ((lastDigit === '2' || lastDigit === '3' || lastDigit === '4') && beforeLastDigit !== '1') {
                return count + ' студента';
            }
            
            return count + ' студентов';
        },
        getCrownClass(place) {
            switch (place) {
                case 1:
                    return 'gold'
                case 2:
                    return 'silver';
                case 3:
                    return 'bronze';
                default:
                    return 'hidden';
            }
        },
        getScoreColor(score) {
            return helpers.getScoreColor(score);
        },
        getPhotoUrl(student) {
            if (student.userLogoUrl) {
                return `${this.apiImg}${student.userLogoUrl}`;
            }

            if (student.userGender === 1) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (student.userGender === 2) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        }
    },
    created() {
        let screenWidth = 1280;

        if (this.full || window.innerWidth <= screenWidth) {
            //для ширины 1280 должно быть >= 17 баллов
            this.minScoreForLabel = Math.ceil(screenWidth * 17 / window.innerWidth);
            this.minScoreForPhoto = Math.ceil(screenWidth * 13 / window.innerWidth);
        } else {
            this.minScoreForLabel = Math.ceil(screenWidth * 26 / window.innerWidth);
            this.minScoreForPhoto = Math.ceil(screenWidth * 18 / window.innerWidth);
        }
    }
}
</script>
